import { createSlice } from '@reduxjs/toolkit';
import { PHYSICS_DEFAULTS } from '../lib/network/constants';
import { PAIR_OFFSET } from '../lib/geometry/edges';
import { DISPLAY_LABEL, defaultShapeForMode } from '../lib/display';

export const initialNetworkState = {
  selectedNode: null, // node being edited in the dialog
  selectedEdge: null, // edge being edited in the dialog
  highlightedNodes: [], // ids selected on the canvas
  highlightedEdges: [],
  physics: false,
  physicsSettings: { ...PHYSICS_DEFAULTS },
  selfReference: true,
  snapToGrid: false,
  offsetPairs: true,
  pairOffset: PAIR_OFFSET,
  displayMode: DISPLAY_LABEL,
  defaultNodeShape: 'ellipse',
  fitRequest: 0,
};

const networkSlice = createSlice({
  name: 'network',
  initialState: initialNetworkState,
  reducers: {
    setSelectedNode: (state, action) => {
      state.selectedNode = action.payload;
    },
    setSelectedEdge: (state, action) => {
      state.selectedEdge = action.payload;
    },
    setHighlightedNodes: (state, action) => {
      state.highlightedNodes = action.payload;
    },
    setHighlightedEdges: (state, action) => {
      state.highlightedEdges = action.payload;
    },
    setSelection: (state, action) => {
      state.highlightedNodes = action.payload.nodes || [];
      state.highlightedEdges = action.payload.edges || [];
    },
    clearSelection: (state) => {
      state.highlightedNodes = [];
      state.highlightedEdges = [];
    },
    setPhysics: (state, action) => {
      state.physics = action.payload;
    },
    setPhysicsSetting: (state, action) => {
      const { key, value } = action.payload;
      state.physicsSettings = { ...PHYSICS_DEFAULTS, ...state.physicsSettings, [key]: value };
    },
    resetPhysicsSettings: (state) => {
      state.physicsSettings = { ...PHYSICS_DEFAULTS };
    },
    setSelfReference: (state, action) => {
      state.selfReference = action.payload;
    },
    setSnapToGrid: (state, action) => {
      state.snapToGrid = action.payload;
    },
    setOffsetPairs: (state, action) => {
      state.offsetPairs = action.payload;
    },
    setPairOffset: (state, action) => {
      state.pairOffset = action.payload;
    },
    setDisplayMode: (state, action) => {
      state.displayMode = action.payload;
      state.defaultNodeShape = defaultShapeForMode(action.payload, state.defaultNodeShape);
    },
    setDefaultNodeShape: (state, action) => {
      state.defaultNodeShape = action.payload;
    },
    requestFit: (state) => {
      state.fitRequest += 1;
    },
  },
});

export const {
  setSelectedNode,
  setSelectedEdge,
  setHighlightedNodes,
  setHighlightedEdges,
  setSelection,
  clearSelection,
  setPhysics,
  setPhysicsSetting,
  resetPhysicsSettings,
  setSelfReference,
  setSnapToGrid,
  setOffsetPairs,
  setPairOffset,
  setDisplayMode,
  setDefaultNodeShape,
  requestFit,
} = networkSlice.actions;
export default networkSlice.reducer;
